module.exports = __webpack_public_path__ + "static/alexFull-55df40c9676bfd73a351c6791ec76125.pdf";